import React from 'react';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { getProductData } from '../../API';
import { asinValidation } from '../../../utils/formikValidations';
import { ESellerStore as Platform } from '../../..//Types';
import * as yup from 'yup';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Step from '../BuildingBlocks/Stepper/Step';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';

const useStyles = makeStyles((theme) => ({
  fieldContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
  field: { maxWidth: 400 },
}));

export default function ProductAsin({ verifyProduct, lastAsinChecked }) {
  const classes = useStyles();
  const { setLoading } = useOnboardingContext();
  const { products } = useLinesContext();
  const { business } = useCompanyContext();
  const { trackEvent } = useEventTrackerContext();
  const isAmazonSeller = business.sellerStore === Platform.amazon;
  const newestProduct = products[products?.length - 1];

  async function handleSubmit(values: { asin: string }) {
    try {
      setLoading(true);
      const productDetails = await getProductData(values.asin);
      verifyProduct(
        values.asin,
        productDetails.name,
        productDetails.image,
        productDetails.url,
        productDetails.bestProductRank,
      );
      trackEvent({ event: 'entered_product_asin', product_asin: values.asin });
    } catch (error) {
      verifyProduct(values.asin, null, null);
    }
    setLoading(false);
  }

  return (
    <Step
      initialValues={{ asin: lastAsinChecked || newestProduct?.asin || '' }}
      validationSchema={yup.object({
        asin: asinValidation(isAmazonSeller),
      })}
      onSubmit={handleSubmit}
      component={() => {
        return (
          <>
            <div className={classes.fieldContainer}>
              <Field
                name="asin"
                label="Product ASIN"
                component={TextField}
                variant="outlined"
                fullWidth
                className={classes.field}
              />
            </div>
          </>
        );
      }}
    />
  );
}
